import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useResetPasswordValidationSchema = () => {
  const { t } = useTranslation();

  return Yup.object({
    password: Yup.string()
      .min(8, t('pages.register.passwordMin'))
      .max(20, t('pages.register.passwordMax'))
      .matches(/[a-z]/, t('pages.register.passwordLowercase'))
      .matches(/[A-Z]/, t('pages.register.passwordUppercase'))
      .matches(/[0-9]/, t('pages.register.passwordNumber'))
      .matches(/[\W_]/, t('pages.register.passwordSpecial'))
      .notOneOf(
        ['password', '12345678', 'abc123'],
        t('pages.register.passwordNotCommon')
      )
      .required(t('pages.register.passwordRequired')),

    confirmPassword: Yup.string()
      .required(t('pages.resetPassword.confirmPasswordRequired'))
      .oneOf(
        [Yup.ref('password'), null],
        t('pages.resetPassword.confirmPasswordMatch')
      ),
  });
};
